module.exports = __webpack_public_path__ + "static/media/binance-logo-small.40945cd8.svg";